var map = {
	"./back.png": 49767,
	"./choose.png": 27841,
	"./copy.png": 91205,
	"./language.png": 39548,
	"./logo.png": 83839,
	"./select.png": 77250,
	"./time.png": 72453,
	"./tips.png": 3452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34320;